import React from 'react';
import CustomerInfo from './CustomerInfo';
import Orders from './Orders';
import Comments from './Comments/Comments';
import Notes from './Notes';
import Divider from '@material-ui/core/Divider';
import Transactions from './Transactions';
import { makeStyles } from '@material-ui/core/styles';
import useRules from "../../../../../../hooks/useRules"
import Alerts from "./Alerts"
import ListPhones from "./Phones/ListPhones"

const useStyles = makeStyles((theme) => ({
  divider: {
    margin: theme.spacing(1, 0),
  },
}));

function CustomerMainCard(props) {
  const classes = useStyles();
  const [rules,hasRule,isAdmin] = useRules();
  return (
    <>
      <Alerts />
      <CustomerInfo />
      <Divider className={classes.divider} />
      <ListPhones />
      <Divider className={classes.divider} />
      <Notes />
      <Divider className={classes.divider} />
      <Orders />
      <Divider className={classes.divider} />
      {hasRule('can_see_transactions') && <Transactions />}
      <Divider className={classes.divider} />
      {/* <Comments /> */}
      {/* <Divider className={classes.divider} /> */}
    </>
  );
}

export default CustomerMainCard;
